<template>
    <div>
        <b-row class="text-center" :style="{ height: '20vh', position: 'relative' }">
            <b-col :style="{ position: 'absolute', bottom: '0px' }">
                <b-spinner label="Loading..."></b-spinner>
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {};
</script>
